'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ShelfItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function ShelfItem(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 33 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 22 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#666' : _ref$color,
      _ref$checkmarkBackgro = _ref.checkmarkBackgroundColor,
      checkmarkBackgroundColor = _ref$checkmarkBackgro === undefined ? '#2F50B3' : _ref$checkmarkBackgro,
      _ref$checkmarkStrokeC = _ref.checkmarkStrokeColor,
      checkmarkStrokeColor = _ref$checkmarkStrokeC === undefined ? '#fff' : _ref$checkmarkStrokeC,
      _ref$lockBackgroundCo = _ref.lockBackgroundColor,
      lockBackgroundColor = _ref$lockBackgroundCo === undefined ? '#2F50B3' : _ref$lockBackgroundCo,
      _ref$lockStrokeColor = _ref.lockStrokeColor,
      lockStrokeColor = _ref$lockStrokeColor === undefined ? '#fff' : _ref$lockStrokeColor,
      _ref$onShelf = _ref.onShelf,
      onShelf = _ref$onShelf === undefined ? false : _ref$onShelf,
      _ref$isPrivate = _ref.isPrivate,
      isPrivate = _ref$isPrivate === undefined ? false : _ref$isPrivate;

  var renderLockIcon = function renderLockIcon() {
    return _react2.default.createElement(
      'g',
      { transform: 'translate(110.000000, 558.000000)' },
      _react2.default.createElement('path', { d: 'M6.62249994,0 C4.41249994,0 2.62249994,1.79 2.62249994,4 L2.62249994,6 L0.622499943,6 L0.622499943,14 L12.6224999,14 L12.6224999,6 L10.6224999,6 L10.6224999,4 C10.6224999,1.79 8.83249994,0 6.62249994,0 Z M6.62249994,2 C7.81249994,2 8.62249994,2.81 8.62249994,4 L8.62249994,6 L4.62249994,6 L4.62249994,4 C4.62249994,2.81 5.43249994,2 6.62249994,2 Z', fill: lockBackgroundColor, fillRule: 'nonzero' }),
      _react2.default.createElement(
        'g',
        { transform: 'translate(3.500000, 7.875000)', fill: lockStrokeColor },
        _react2.default.createElement('polygon', { id: 'Checkmark', points: '2.79600174 2.66464878 1.33994949 1.20859653 0.35 2.19854602 2.76482323 4.61336925 3.75477272 3.62341976 6.37158225 0.989949494 5.38163276 1.33226763e-15' })
      )
    );
  };

  var renderCheckmark = function renderCheckmark() {
    return _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', transform: 'translate(110.000000, 558.000000)' },
      _react2.default.createElement('circle', { className: 'CheckBackground', fill: checkmarkBackgroundColor, cx: '6', cy: '6', r: '6' }),
      _react2.default.createElement('polygon', { className: 'Checkmark', fill: checkmarkStrokeColor, points: '5.49428821 6.80664111 3.41421356 4.72656647 2 6.14078003 5.44974747 9.5905275 6.86396103 8.17631394 10.6022604 4.41421356 9.1880468 3' })
    );
  };

  var renderOnShelfIcon = function renderOnShelfIcon() {
    if (onShelf && isPrivate) {
      return renderLockIcon();
    } else if (onShelf) {
      return renderCheckmark();
    }

    return null;
  };

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-shelf-item ' + className, width: width, height: height, viewBox: '89 558 33 22', version: '1.1' },
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', transform: 'translate(97.000000, 560.000000)' },
      _react2.default.createElement(
        'g',
        { fill: color },
        _react2.default.createElement(
          'g',
          { transform: 'translate(12.631579, 2.089245)' },
          _react2.default.createElement('path', { d: 'M3.68421053,2.26544622 L3.36842105,0.926773455 C3.36842105,0.823798627 3.26315789,0.720823799 3.15789474,0.720823799 L0.315789474,1.23569794 C0.210526316,1.23569794 0.105263158,1.33867277 0.105263158,1.4416476 L0.421052632,2.78032037 L3.68421053,2.26544622 L3.68421053,2.26544622 Z' }),
          _react2.default.createElement('polygon', { points: '3.79077895 3.16967849 5.92558947 13.5682002 2.72638947 14.1967483 0.591578947 3.79822654' }),
          _react2.default.createElement('path', { d: 'M2.94736842,15.0343249 L3.26315789,16.3729977 C3.26315789,16.4759725 3.36842105,16.4759725 3.47368421,16.4759725 L6.31578947,15.9610984 C6.42105263,15.9610984 6.52631579,15.8581236 6.52631579,15.7551487 L6.10526316,14.416476 L2.94736842,15.0343249 L2.94736842,15.0343249 Z' })
        ),
        _react2.default.createElement(
          'g',
          { transform: 'translate(6.315789, 0.000000)' },
          _react2.default.createElement('path', { d: 'M5.68421053,2.29519451 L5.68421053,0.338672769 C5.68421053,0.235697941 5.57894737,0.0297482838 5.36842105,0.0297482838 L1.15789474,0.0297482838 C0.947368421,0.0297482838 0.842105263,0.132723112 0.842105263,0.338672769 L0.842105263,2.29519451 L5.68421053,2.29519451 L5.68421053,2.29519451 Z' }),
          _react2.default.createElement('rect', { x: '0.842105263', y: '3.11899314', width: '4.73684211', height: '12.9748284' }),
          _react2.default.createElement('path', { d: 'M0.842105263,17.020595 L0.842105263,18.3592677 C0.842105263,18.4622426 0.947368421,18.5652174 1.05263158,18.5652174 L5.36842105,18.5652174 C5.47368421,18.5652174 5.68421053,18.4622426 5.68421053,18.3592677 L5.68421053,17.020595 L0.842105263,17.020595 L0.842105263,17.020595 Z' })
        ),
        _react2.default.createElement(
          'g',
          { transform: 'translate(0.000000, 1.059497)' },
          _react2.default.createElement('path', { d: 'M5.68421053,2.78032037 L5.68421053,0.823798627 C5.68421053,0.720823799 5.57894737,0.61784897 5.47368421,0.61784897 L0.315789474,0.61784897 C0.210526316,0.61784897 0.105263158,0.720823799 0.105263158,0.823798627 L0.105263158,2.78032037 L5.68421053,2.78032037 L5.68421053,2.78032037 Z' }),
          _react2.default.createElement('rect', { x: '0.105263158', y: '3.60411899', width: '5.57894737', height: '11.4302059' }),
          _react2.default.createElement('path', { d: 'M0.105263158,15.9610984 L0.105263158,17.2997712 C0.105263158,17.402746 0.210526316,17.5057208 0.315789474,17.5057208 L5.36842105,17.5057208 C5.47368421,17.5057208 5.57894737,17.402746 5.57894737,17.2997712 L5.57894737,15.9610984 L0.105263158,15.9610984 L0.105263158,15.9610984 Z' })
        )
      )
    ),
    renderOnShelfIcon()
  );
}

ShelfItem.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/ShelfItem/ShelfItem.js
// module id = 315
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15